/* esm.sh - rxjs@7.8.2/dist/esm/internal/operators/min */
import{reduce as r}from"rxjs/dist/esm/internal/operators/reduce";import{isFunction as t}from"rxjs/dist/esm/internal/util/isFunction";function e(o){return r(t(o)?(i,n)=>o(i,n)<0?i:n:(i,n)=>i<n?i:n)}export{e as min};
//# sourceMappingURL=min.mjs.map